module.exports = __webpack_public_path__ + "img/downloads_ies3_with_surgical_units.66c8200d.jpg";